import { useState, useEffect } from 'react';
import { Autor } from '../../types';
import { api } from '../../api/client';
import AutorForm from './AutorForm';

export default function AutorList() {
  const [autores, setAutores] = useState<Autor[]>([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingAutor, setEditingAutor] = useState<Autor | null>(null);

  useEffect(() => {
    loadAutores();
  }, []);

  const loadAutores = async () => {
    const data = await api.autores.list();
    setAutores(data);
    setLoading(false);
  };

  const handleDelete = async (id: number) => {
    if (!window.confirm('¿Eliminar este autor? Las noticias asociadas podrían quedar huérfanas.')) return;
    await api.autores.delete(id);
    loadAutores();
  };

  const handleEdit = (a: Autor) => {
    setEditingAutor(a);
    setShowForm(true);
  };

  const handleFormSubmit = () => {
    setShowForm(false);
    setEditingAutor(null);
    loadAutores();
  };

  if (loading) return <p>Cargando autores...</p>;

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Autores</h1>
        <button
          onClick={() => setShowForm(true)}
          className="bg-green-600 text-white px-4 py-2 rounded"
        >
          + Nuevo Autor
        </button>
      </div>

      {showForm && (
        <AutorForm
          initialData={editingAutor || undefined}
          onSubmit={handleFormSubmit}
          onCancel={() => {
            setShowForm(false);
            setEditingAutor(null);
          }}
          isEdit={!!editingAutor}
          id={editingAutor?.id_autor}
        />
      )}

      <div className="space-y-4">
        {autores.map((a) => (
          <div key={a.id_autor} className="border rounded p-4 bg-white shadow flex justify-between items-center">
            <div>
              <h3 className="font-bold">{a.nombre_autor}</h3>
              {a.url_imagen && (
                <img src={a.url_imagen} alt={a.nombre_autor} className="w-12 h-12 object-cover rounded mt-2" />
              )}
            </div>
            <div className="space-x-2">
              <button
                onClick={() => handleEdit(a)}
                className="text-blue-600 hover:underline"
              >
                Editar
              </button>
              <button
                onClick={() => handleDelete(a.id_autor)}
                className="text-red-600 hover:underline"
              >
                Eliminar
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}